export const categories = [
  {
    slug: "music",
    name: "音乐",
    enName: "MUSIC",
    tagline: "巡演 · 唱片 · 现场",
    description:
      "从华语巡演到独立厂牌，从黑胶复兴到影视原声，噜噜社音乐频道追踪乐坛的每一次心跳，为你筛选值得单曲循环的声音。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20music%20stage%20scene%20with%20warm%20orange%20spotlights%20and%20silhouette%20of%20a%20singer%2C%20abstract%20editorial%20poster%20art%2C%20rich%20amber%20and%20deep%20charcoal%20tones%2C%20grainy%20texture%2C%20minimal%20composition%2C%20high%20contrast&width=800&height=600&seq=lulu-cat-music&orientation=landscape",
    icon: "ri-music-2-line",
    accent: "primary",
  },
  {
    slug: "film",
    name: "影视",
    enName: "FILM & TV",
    tagline: "院线 · 剧集 · 纪录片",
    description:
      "院线复盘、剧集观察、纪录片现场，噜噜社影视频道用冷静的视角拆解镜头背后的叙事逻辑与行业变化。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinema%20scene%20with%20projector%20beam%20and%20empty%20red%20velvet%20seats%2C%20abstract%20editorial%20poster%20art%2C%20deep%20charcoal%20with%20warm%20accent%20glow%2C%20grainy%20texture%2C%20minimal%20composition%2C%20high%20contrast&width=800&height=600&seq=lulu-cat-film&orientation=landscape",
    icon: "ri-film-line",
    accent: "accent",
  },
  {
    slug: "fashion",
    name: "时尚",
    enName: "FASHION",
    tagline: "秀场 · 造型 · 可持续",
    description:
      "四大时装周趋势、造型解析与可持续时尚实践，噜噜社时尚频道把秀场语言翻译成你衣橱里真正用得上的灵感。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20fashion%20runway%20scene%20with%20abstract%20sculptural%20garment%20on%20a%20mannequin%2C%20editorial%20poster%20art%2C%20soft%20beige%20and%20burnt%20orange%20palette%2C%20grainy%20texture%2C%20minimal%20composition%2C%20high%20contrast&width=800&height=600&seq=lulu-cat-fashion&orientation=landscape",
    icon: "ri-t-shirt-line",
    accent: "secondary",
  },
  {
    slug: "trend",
    name: "潮流文化",
    enName: "STREET CULTURE",
    tagline: "街头 · 复古 · 城市生活",
    description:
      "街头文化、复古回潮、Citywalk 与青年社群，噜噜社潮流文化频道记录正在发生的亚文化，以及它们如何进入主流视野。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20urban%20skate%20park%20scene%20with%20concrete%20ramps%20and%20abstract%20graffiti%20shapes%2C%20editorial%20poster%20art%2C%20warm%20orange%20and%20cool%20blue%20accents%20on%20grey%2C%20grainy%20texture%2C%20minimal%20composition&width=800&height=600&seq=lulu-cat-trend&orientation=landscape",
    icon: "ri-fire-line",
    accent: "primary",
  },
];